/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginAccountRequest
 */
export interface LoginAccountRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof LoginAccountRequest
     */
    readonly $schema?: string;
    /**
     * Password
     * @type {string}
     * @memberof LoginAccountRequest
     */
    password: string;
    /**
     * Recaptcha token
     * @type {string}
     * @memberof LoginAccountRequest
     */
    recaptchaToken: string;
    /**
     * Retrieve device keys
     * @type {boolean}
     * @memberof LoginAccountRequest
     */
    retrieveDeviceKeys: boolean;
    /**
     * Username
     * @type {string}
     * @memberof LoginAccountRequest
     */
    username: string;
}

/**
 * Check if a given object implements the LoginAccountRequest interface.
 */
export function instanceOfLoginAccountRequest(value: object): value is LoginAccountRequest {
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('recaptchaToken' in value) || value['recaptchaToken'] === undefined) return false;
    if (!('retrieveDeviceKeys' in value) || value['retrieveDeviceKeys'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function LoginAccountRequestFromJSON(json: any): LoginAccountRequest {
    return LoginAccountRequestFromJSONTyped(json, false);
}

export function LoginAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'password': json['password'],
        'recaptchaToken': json['recaptcha_token'],
        'retrieveDeviceKeys': json['retrieve_device_keys'],
        'username': json['username'],
    };
}

export function LoginAccountRequestToJSON(json: any): LoginAccountRequest {
    return LoginAccountRequestToJSONTyped(json, false);
}

export function LoginAccountRequestToJSONTyped(value?: Omit<LoginAccountRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
        'recaptcha_token': value['recaptchaToken'],
        'retrieve_device_keys': value['retrieveDeviceKeys'],
        'username': value['username'],
    };
}

